module.exports = __webpack_public_path__ + "img/0Q3B8222.61d54b0b.webp";